module.exports = __webpack_public_path__ + "google-d8d920a6d71605aa4072.svg";